export const forms = {
	ThingNameForm: import('./ThingNameForm'),
};
